module.exports = __webpack_public_path__ + "classic-black-selector.7ba0e69c78b9b945b0ae.png";


//////////////////
// WEBPACK FOOTER
// /vercel/workpath0/src/assets/img/classic-black-selector.png
// module id = ../../../../../src/assets/img/classic-black-selector.png
// module chunks = main